import ACTIONS, { FETCH_STATUS } from "../constants";

export const getAuditLogList = {
  pending: { type: ACTIONS.AUDIT_LOG_LIST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.AUDIT_LOG_LIST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.AUDIT_LOG_LIST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const getAuditLogListRequest = (payload) => ({
  type: ACTIONS.AUDIT_LOG_LIST_CALL,
  payload,
});

export const getEntityActivity = {
  pending: { type: ACTIONS.ENTITY_ACTIVITY.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.ENTITY_ACTIVITY.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.ENTITY_ACTIVITY.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const getEntityActivityRequest = (payload) => ({
  type: ACTIONS.ENTITY_ACTIVITY_CALL,
  payload,
});

export const getAuditLogEntityTypes = {
  pending: { type: ACTIONS.AUDIT_LOG_ENTITY_TYPES.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.AUDIT_LOG_ENTITY_TYPES.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.AUDIT_LOG_ENTITY_TYPES.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const getAuditLogEntityTypesRequest = () => ({
  type: ACTIONS.AUDIT_LOG_ENTITY_TYPES_CALL,
});

export const exportAuditLog = {
  pending: { type: ACTIONS.AUDIT_LOG_EXPORT.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.AUDIT_LOG_EXPORT.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.AUDIT_LOG_EXPORT.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const exportAuditLogRequest = (payload) => ({
  type: ACTIONS.AUDIT_LOG_EXPORT_CALL,
  payload,
});

export const resetEntityActivity = () => ({
  type: ACTIONS.RESET_ENTITY_ACTIVITY,
});
